import React from 'react';

const Testimonials = () => {
  return (
    <section className="bg-gray-100 py-20 text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-black">What Our Users Are Saying</h2>
        <p className="text-gray-600 mt-4">Hear from those who have already joined HaulRadar.</p>

        <div className="mt-16 flex flex-wrap justify-center">
          <div className="w-full md:w-1/3 px-6 mb-12">
            <div className="bg-black p-8 rounded-lg shadow-lg">
              <p className="text-lg italic text-gray-200">"HaulRadar has transformed the way we haul material into our yard. It's incredibly easy to use and has saved us so much time!"</p>
              <p className="text-gray-400 mt-4">- Kevin Carson, Audubon Orgaincs</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
